import "@/App.css";
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import PortalLayout from "@/components/PortalLayout";
import HomePage from "@/pages/HomePage";
import RatesPage from "@/pages/RatesPage";
import PricingPage from "@/pages/PricingPage";
import ReferralPage from "@/pages/ReferralPage";
import ContactPage from "@/pages/ContactPage";
import AboutPage from "@/pages/AboutPage";
import FAQPage from "@/pages/FAQPage";
import TermsPage from "@/pages/TermsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import DownloadsPage from "@/pages/DownloadsPage";
import LoginPage from "@/pages/portal/LoginPage";
import DashboardPage from "@/pages/portal/DashboardPage";
import SIPAccountsPage from "@/pages/portal/SIPAccountsPage";
import CDRPage from "@/pages/portal/CDRPage";
import RechargePage from "@/pages/portal/RechargePage";
import SoftphonePage from "@/pages/portal/SoftphonePage";
import { AuthProvider } from "@/context/AuthContext";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<Layout />}>
              <Route index element={<HomePage />} />
              <Route path="rates" element={<RatesPage />} />
              <Route path="pricing" element={<PricingPage />} />
              <Route path="referral" element={<ReferralPage />} />
              <Route path="contact" element={<ContactPage />} />
              <Route path="about" element={<AboutPage />} />
              <Route path="faq" element={<FAQPage />} />
              <Route path="terms" element={<TermsPage />} />
              <Route path="privacy" element={<PrivacyPage />} />
              <Route path="download" element={<DownloadsPage />} />
              <Route path="downloads" element={<Navigate to="/download" replace />} />
              <Route path="downlaod" element={<Navigate to="/download" replace />} />
              <Route path="downlaods" element={<Navigate to="/download" replace />} />
            </Route>
            
            {/* Portal routes */}
            <Route path="/portal/login" element={<LoginPage />} />
            <Route path="/portal" element={<PortalLayout />}>
              <Route index element={<DashboardPage />} />
              <Route path="dashboard" element={<DashboardPage />} />
              <Route path="sip" element={<SIPAccountsPage />} />
              <Route path="cdr" element={<CDRPage />} />
              <Route path="recharge" element={<RechargePage />} />
              <Route path="softphone" element={<SoftphonePage />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
